# --------------------------------------------------*|
#   Common.Directives.Select
# --------------------------------------------------*|

angular.module("siter.io").directive "strSelect", ["$window", "$timeout", "$compile", ($window, $timeout, $compile) ->
  restrict: "A"
  require: "?ngModel"
  scope: true
  link: (scope, element, attrs, ngModel) ->


    if attrs.selectReplace is "true" || attrs.selectReplace is "false"
      attrs.selectReplace = JSON.parse(attrs.selectReplace)
    else
      attrs.selectReplace = true

    replace = attrs.selectReplace
    backdropEditor = attrs.selectEditor || false

    el = $(element)
    placeholder = el.find('.select__placeholder')
    selectBackdrop = 'select-backdrop'

    scope.optionCheck = (event, value) ->
      ngModel.$setViewValue value
      ngModel.$render();
      el.find('.dropdown__option').removeClass 'option_active'
      if replace
        placeholder.html $(event.target).text()
      $(event.target).addClass 'option_active'
      scope.closeSelect()
      return

    scope.initSelect = ->
      el.addClass 'select_active'
      if backdropEditor == 'true'
        $(element).after($compile('<div class="'+selectBackdrop+'" ng-click="closeSelect()"></div>')(scope.$new()))
      else
        $('body').append($compile('<div class="'+selectBackdrop+'" ng-click="closeSelect()"></div>')(scope.$new()))
      return

    scope.closeSelect = ->
      if attrs.asDropdown
        el.find(".option_active").removeClass "option_active"
      el.removeClass 'select_active'
      $('.'+selectBackdrop).remove()
      return


    placeholder.on 'click', ->
      if !$('.'+selectBackdrop)[0]
        scope.initSelect()
        $(document).keyup (e) ->
          if e.keyCode is 27
            scope.closeSelect()
          return
        if attrs.selectBg is 'true'
          $('.'+selectBackdrop).addClass('modal-backdrop in')
        return
      else
        scope.closeSelect()
        return
      return
]



// WEBPACK FOOTER //
// ./src/app/common/directives/select.directive.coffee